import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { ICaja } from '../../interfaces/ICaja';
import { ICajaResume } from '@/interfaces/ICajaResume';
import { ICajaMovement } from '@/interfaces/ICajaMovement';

const apiUrl =
  Globals.apiPath + '/restaurants/:restaurantId/branches/:branchId/cajas';

function getApiUrl(restaurantId: number, branchId: number) {
  return apiUrl
    .replace(':restaurantId', restaurantId.toString())
    .replace(':branchId', branchId.toString());
}

export default class CajasService {
  constructor() {}

  static async getAll(
    restaurantId: number,
    branchId: number
  ): Promise<ICaja[]> {
    let res = await axios.get<ICaja[]>(`${getApiUrl(restaurantId, branchId)}`);
    return res.data;
  }

  static async getById(
    restaurantId: number,
    branchId: number,
    id: number
  ): Promise<ICaja> {
    let res = await axios.get<ICaja>(
      `${getApiUrl(restaurantId, branchId)}/${id}`
    );
    return res.data;
  }

  static async getResume(
    restaurantId: number,
    branchId: number,
    id: number
  ): Promise<ICajaResume> {
    let res = await axios.get<ICajaResume>(
      `${getApiUrl(restaurantId, branchId)}/${id}/resume`
    );
    return res.data;
  }

  static async closePreview(
    restaurantId: number,
    branchId: number,
    id: number
  ): Promise<{ blockingCount: number; carryOverCount: number }> {
    let res = await axios.get<{
      blockingCount: number;
      carryOverCount: number;
    }>(`${getApiUrl(restaurantId, branchId)}/${id}/close-preview`);
    return res.data;
  }

  static async create(data: {
    restaurantId: number;
    branchId: number;
    name: string;
    adminKey: number;
  }): Promise<ICaja> {
    let res = await axios.post<ICaja>(
      getApiUrl(data.restaurantId, data.branchId),
      {
        name: data.name,
        adminKey: data.adminKey,
      }
    );
    return res.data;
  }

  static async update(
    caja: {
      restaurantId: number;
      branchId: number;
      id: number;
    },
    data: { name?: string; adminKey?: number }
  ): Promise<ICaja> {
    let res = await axios.put<ICaja>(
      `${getApiUrl(caja.restaurantId, caja.branchId)}/${caja.id}`,
      {
        name: data.name,
        adminKey: data.adminKey,
      }
    );
    return res.data;
  }

  static async delete(caja: ICaja): Promise<ICaja> {
    let res = await axios.put<ICaja>(
      `${getApiUrl(caja.restaurantId, caja.branchId)}/${caja.id}`
    );
    return res.data;
  }

  static async activate(caja: ICaja): Promise<ICaja> {
    let res = await axios.put<ICaja>(
      `${getApiUrl(caja.restaurantId, caja.branchId)}/${caja.id}/enable`
    );
    return res.data;
  }

  static async deactivate(caja: ICaja): Promise<ICaja> {
    let res = await axios.put<ICaja>(
      `${getApiUrl(caja.restaurantId, caja.branchId)}/${caja.id}/disable`
    );
    return res.data;
  }

  static async checkKey(caja: ICaja, key: number): Promise<ICaja> {
    let res = await axios.post<ICaja>(
      `${getApiUrl(caja.restaurantId, caja.branchId)}/${caja.id}/checkKey`,
      {
        key,
      }
    );
    return res.data;
  }

  static async getHistoric({
    restaurantId,
    branchId,
    cajaId,
    dateFrom,
    dateTo,
  }: {
    restaurantId: number;
    branchId: number;
    cajaId?: number;
    dateFrom: Date;
    dateTo?: Date;
  }): Promise<ICajaMovement[]> {
    let url = `${getApiUrl(
      restaurantId,
      branchId
    )}/historic?from=${dateFrom.toISOString()}`;

    if (cajaId) url += `&c=${cajaId}`;

    if (dateTo) url += `&to=${dateTo.toISOString()}`;

    let res = await axios.get<ICajaMovement[]>(url);
    return res.data;
  }
}
